app.userEvents.lixoButtonClick = function(event) {
	// Your code goes here...
	return true;
}